import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "zmncraft_cookie_consent";
const CONSENT_VERSION = "cookies-v1-2026-05-25";
const METRIKA_ID = 107084721;

function readConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.version !== CONSENT_VERSION) return null;
    if (parsed?.analytics === "accepted" || parsed?.analytics === "rejected") return parsed;
    return null;
  } catch {
    return null;
  }
}

function writeConsent(analytics) {
  const value = {
    analytics,
    version: CONSENT_VERSION,
    acceptedAt: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  return value;
}

function loadYandexMetrika() {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (window.__zmncraftMetrikaLoaded) return;

  window.__zmncraftMetrikaLoaded = true;

  (function (m, e, t, r, i, k, a) {
    m[i] = m[i] || function () {
      (m[i].a = m[i].a || []).push(arguments);
    };
    m[i].l = 1 * new Date();
    for (var j = 0; j < e.scripts.length; j += 1) {
      if (e.scripts[j].src === r) return;
    }
    k = e.createElement(t);
    a = e.getElementsByTagName(t)[0];
    k.async = 1;
    k.src = r;
    a.parentNode.insertBefore(k, a);
  })(window, document, "script", `https://mc.yandex.ru/metrika/tag.js?id=${METRIKA_ID}`, "ym");

  window.ym(METRIKA_ID, "init", {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: "dataLayer",
    referrer: document.referrer,
    url: window.location.href,
    accurateTrackBounce: true,
    trackLinks: true,
  });
}

export default function CookieConsent() {
  const [consent, setConsent] = useState(() => readConsent());

  useEffect(() => {
    if (consent?.analytics === "accepted") loadYandexMetrika();
  }, [consent]);

  if (consent) return null;

  const acceptAnalytics = () => {
    setConsent(writeConsent("accepted"));
  };

  const rejectAnalytics = () => {
    setConsent(writeConsent("rejected"));
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:px-6">
      <div className="mx-auto max-w-5xl rounded-2xl border border-gray-200 bg-white/95 p-4 shadow-2xl backdrop-blur dark:border-gray-700 dark:bg-gray-950/95 sm:p-5">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div className="text-sm leading-6 text-gray-700 dark:text-gray-300">
            <div className="font-extrabold text-gray-900 dark:text-gray-100">
              Cookies и Яндекс Метрика
            </div>
            <div className="mt-1">
              Сайт использует необходимые cookies для работы интерфейса. Аналитические
              cookies и Яндекс Метрика включаются только после вашего согласия. Подробнее
              в{" "}
              <Link
                to="/privacy-policy"
                className="font-semibold text-violet-700 hover:text-violet-900 dark:text-violet-300 dark:hover:text-violet-200"
              >
                Политике обработки персональных данных
              </Link>
              .
            </div>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row lg:shrink-0">
            <button
              type="button"
              onClick={rejectAnalytics}
              className="inline-flex min-h-11 items-center justify-center rounded-2xl border border-gray-300 px-5 py-2.5 text-sm font-semibold text-gray-800 transition-colors hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 dark:border-gray-700 dark:text-gray-100 dark:hover:bg-gray-800"
            >
              Только необходимые
            </button>
            <button
              type="button"
              onClick={acceptAnalytics}
              className="inline-flex min-h-11 items-center justify-center rounded-2xl bg-gradient-to-r from-cyan-500 via-violet-600 to-violet-950 px-5 py-2.5 text-sm font-semibold text-white shadow-lg transition-transform focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 motion-safe:hover:scale-[1.02]"
            >
              Принять аналитику
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
